import React from 'react';
import styles from './MobileTapArea.module.scss';

interface MobileTapAreaProps {
  side: 'left' | 'right';
  onPressStart: () => void;
  onPressEnd: () => void;
  height?: string;
}

export const MobileTapArea: React.FC<MobileTapAreaProps> = ({
  side,
  onPressStart,
  onPressEnd,
  height = '100%',
}) => {
  return (
    <div
      className={styles.tapArea}
      style={{ height, touchAction: 'none' }}
      onMouseDown={onPressStart}
      onMouseUp={onPressEnd}
      onTouchStart={onPressStart}
      onTouchEnd={onPressEnd}
      onTouchCancel={onPressEnd}
      aria-label={`${side === 'left' ? 'Previous' : 'Next'} slide or hold to pause`}
    />
  );
};
